<template>
  <div class="customer-sidebar">
    <div
      class="sidebar-backdrop"
      @click.stop="closeSidebarPanel"
      v-if="isPanelOpen"
    >
    </div>
    <transition name="slide">
      <div
        v-if="isPanelOpen"
        class="sidebar-panel"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isPanelOpen: false
    }
  },
  methods: {
    openSidebarPanel () {
      this.isPanelOpen = true
    },
    closeSidebarPanel (evt) {
      this.isPanelOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* slide */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}
</style>

<style lang="scss">
@import "@/assets/css/_variables.scss";

.customer-sidebar {
  /* slide mask */
  .sidebar-backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: map-get($z-index, sidebar);
  }
  /* slide content */
  .sidebar-panel {
    overflow-y: auto;
    background-color: white;
    color: black;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: map-get($z-index, sidebar_content);
    width: 15em;
    max-width: 90%;
    .sidebar-header {
      padding: 1em;
      background: $papayum_red;
      color: $basic-white;
    }
    ul.sidebar-content {
      padding: 0.5em 0;
      p {
        color: black;
        padding: 10px;
      }
      li {
        a {
          color: black;
          text-decoration: none;
          padding: 10px;
          font-size: 1.1em;
          display: block;
        }
        a:hover {
          background: $light-gray;
        }
        a.disabled {
          pointer-events: none;
          text-decoration: none;
          color: $light-gray;
        }
        ul {
          a {
            font-size: 0.9em !important;
            padding-left: 1.5em !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Sidebar.vue